import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgShieldTick = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 16.4333 17.686",
	...props,
	children: [
		/* @__PURE__ */ _jsx("title", { children: "shield-tick" }),
		/* @__PURE__ */ _jsx("path", {
			d: "M4.46666 8.76256L6.77435 11.1104L11.9667 6.61039",
			fill: "none",
			stroke: "currentColor",
			strokeWidth: 1.125,
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M8.21667 0.610391L0.5625 3.83539V8.11789C0.5625 10.2079 1.28667 12.1054 2.72583 13.8196C4.17417 15.5337 5.99833 16.6246 8.21667 17.1104C10.435 16.6337 12.2683 15.5337 13.7075 13.8196C15.1558 12.1054 15.8708 10.2079 15.8708 8.11789V3.83539L8.21667 0.610391Z",
			fill: "none",
			stroke: "currentColor",
			strokeWidth: 1.125,
			strokeMiterlimit: 10
		})
	]
});
export { SvgShieldTick as ReactComponent };
